import React, { useEffect, useState } from "react";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";

const VehicleRenewalStatus = ({ renewalDate }) => {
  const [renewalStatus, setRenewalStatus] = useState("");
  const [formattedDate, setFormattedDate] = useState("Nil");

  useEffect(() => {
    if (!renewalDate) return;

    const currentDate = new Date();
    const renewalDateObj = new Date(renewalDate);
    
    // Calculate the difference in days
    const dateDiff = Math.floor((renewalDateObj - currentDate) / (1000 * 60 * 60 * 24));

    let status = "";
    if (dateDiff >= 0 && dateDiff <= 3) {
      status = "Renewal";
    } else if (dateDiff < 0) {
      status = "Expired";
    }

    setRenewalStatus(status);
    setFormattedDate(renewalDateObj.toLocaleDateString("en-GB")); // Convert to DD/MM/YYYY
  }, [renewalDate]);

  return (
    <div className="form-group">
      <label>Renewal Date: </label>
      <input
  type="text"
  name="renewal_date"
  value={`${formattedDate} ${renewalStatus}`}
  readOnly
  className={renewalStatus === "Expired" ? "text-red" : renewalStatus === "Renewal" ? "text-orange" : "text-green"}
/>

    </div>
  );
};

export default VehicleRenewalStatus;
